<template>
    <div>
        <div class="header-main">
            <div class="header">
                <div class="head-left">
                </div>
                <div class="header-right">
                    <el-button v-text-lbl="'printPersonSeat'" icon="" @click="seatSelectBtn">排座调整</el-button>
                    <el-button v-text-lbl="'printPersonSeat'" icon="" @click="print('people')">打印水牌</el-button>
                    <el-button v-text-lbl="'printMeeting'" icon="" @click="print('pic')">下载座位图</el-button>
                </div>
            </div>
        </div>
        <div class="mainBox">
            <div class="main">
            <div class="left" :style="{ height: leftHeight }">
                <div ref="enterDivWrap"></div>
            </div>
            <div class="right">
                <div v-text-lbl="'meetinger'" class="title">{{ row.meetPlace }}</div>
                <div>
                    <span v-field-lbl="'attendLeader'" style="display: inline-block;padding: 15px 15px 0 15px;">出席领导 ：</span>
                    <div class="seatType">

                        <template v-if="leaderList.length > 0">
                            <template v-if="!isDel">
                                <div v-for="item in leaderList" :key="item.id" class="humanBlock" :class="{ cursorPdrag: filterName(item.name) === false }">{{ item.name }}</div>
                            </template>
                        </template>
                    </div>
                    <span v-field-lbl="'meetHost'" style="display: inline-block;padding: 15px 15px 0 15px;">会议主持人：</span>
                    <div class="seatType">
                        <template v-if="hostList.length > 0">
                            <template v-if="!isDel">
                                <div v-for="item in hostList" :key="item.id" class="humanBlock" :class="{ cursorPdrag: filterName(item.name) === false }">{{ item.name }}</div>
                            </template>
                        </template>
                    </div>
                    <span v-field-lbl="'summaryName'" style="display: inline-block;padding: 15px 15px 0 15px;">会议纪要人员：</span>
                    <div class="seatType">
                        <template v-if="summaryList.length > 0">
                            <template v-if="!isDel">
                                <div v-for="item in summaryList" :key="item.id" class="humanBlock" :class="{ cursorPdrag: filterName(item.name) === false }">{{ item.name }}</div>
                            </template>
                        </template>
                    </div>
                    <span v-if="otherList.length > 0" v-field-lbl="'participants'" style="display: inline-block;padding: 15px 15px 0 15px;">参会人员：</span>
                    <div class="seatType">
                        <template v-if="otherList.length > 0">
                            <template v-if="!isDel">
                                <div v-for="item in otherList" :key="item.id" class="humanBlock" :class="{ cursorPdrag: filterName(item.name) === false }">{{ item.name }}</div>
                            </template>
                        </template>
                    </div>
                </div>
            </div>
            <!-- </template> -->
        </div>
        </div>
        <iframe id="iframe" ref="iframe" width="100%" height="200px" style="display: none"></iframe>
        <el-dialog v-if="isShow" ref="diaLog" v-el-drag-dialog append-to-body class="lyy-pd" :title="dialogTitle" :visible.sync="isShow" :close-on-click-modal="false" :width="printType === 'pic' ? '1200px' : '900px'" custom-class="preview_dialog">
            <!-- <div v-if="printType === 'pic'" ref="printCont" class="printCont" v-html="printCont"></div> -->
            <div v-if="printType === 'pic'" ref="printCont" style="position: relative" class="preview_dialog_pic">
                <div class="preview_dialog_pic_scale" style="display: inline-flex; flex-direction: column; justify-content: center; align-items: center; padding: 30px; position: absolute" v-html="printCont"></div>
            </div>
            <div v-if="printType === 'people'" style="display: flex">
                <!-- <div class="pleft" :style="{height:printHeight}"> -->
                <div class="pleft">
                    <!-- <div v-text-lbl="'labelSize'" class="ptitle">标签尺寸</div> -->
                    <table border="1" class="list">
                        <tr>
                            <td v-text-lbl="'long'" align="right" class="tdBg" style="width: 80px; text-align: center">字体大小</td>
                            <td>
                                <div>
                                    <!-- <div style="display: flex;border-bottom: 1px solid #e2e2e2;">
                                        <div style="min-width: 50px;text-align: center;line-height: 44px;border-right: 1px solid #e2e2e2;">长</div>
                                        <div style="padding: 4px;">
                                            <el-input v-model="labelLong" type="number" placeholder="" autocomplete="off" @change="lableSizeChange">
                                                <template slot="append">cm</template>
                                            </el-input>
                                        </div>
                                    </div> -->
                                    <!-- <div style="display: flex;">
                                        <div style="min-width: 50px;text-align: center;line-height: 44px;border-right: 1px solid #e2e2e2;">宽</div>
                                        <div style="padding: 4px;">
                                            <el-input v-model="labelWidth" type="number" placeholder="" autocomplete="off" @change="lableSizeChange">
                                                <template slot="append">cm</template>
                                            </el-input>
                                        </div>
                                    </div> -->
                                    <div style="display: flex;">
                                        <!-- <div style="min-width: 50px;text-align: center;line-height: 44px;border-right: 1px solid #e2e2e2;">宽</div> -->
                                        <div style="padding: 4px;">
                                            <el-input v-model="fontSizePrint" type="number" placeholder="" autocomplete="off">
                                                <template slot="append">px</template>
                                            </el-input>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td v-text-lbl="'long'" align="right" class="tdBg" style="width: 80px; text-align: center">标签设置</td>
                            <td>
                                <el-checkbox-group v-model="checkList">
                                    <el-checkbox label="姓名" disabled></el-checkbox>
                                    <el-checkbox label="职务"></el-checkbox>
                                </el-checkbox-group>
                            </td>
                        </tr>

                        <tr>
                            <td v-text-lbl="'long'" align="right" class="tdBg" style="width: 80px; text-align: center">打印纸张</td>
                            <td>
                                <el-radio-group v-model="dyzz" @input="dyzzChange">
                                    <el-radio :label="1">A4</el-radio>
                                    <el-radio :label="2">A3</el-radio>
                                </el-radio-group>
                            </td>
                        </tr>
                        <tr>
                            <!-- <td v-text-lbl="'long'" align="right" class="tdBg" style="width: 80px; text-align: center">预览</td> -->
                            <td :style="{'height': dyzz==1?'394px':'516px'}" colspan="2">
                                <div ref="A4Inner" style="position: relative;" :class="dyzz===1?'A4Inner':'A3Inner'">
                                    <table style="margin: unset; width: 100%; display: flex; flex-wrap: wrap;">
                                    <template v-for="(item,index) in realSeatArr">
                                            <!-- <tbody :key="index" class="labelTag" style="border: 0px; display: flex; align-items: center; justify-content: center; margin: 0px; font-weight: bold; letter-spacing: 2px" :style="{ width: labelLongM, height: labelWidthM, fontSize: (13 * (parseInt(labelWidth) / 3 + parseInt(labelLong) / 10)) / 2 + 'px', 'page-break-inside': 'avoid' }"> -->
                                                <tbody v-if="(dyzz===1?index<2:index<4)" :key="index" class="labelTag" style="overflow: hidden;border: 0px; display: flex; align-items: center; justify-content: center; margin: 0px; font-weight: bold; letter-spacing: 2px" :style="{ width: labelLongM, height: labelWidthM, fontSize: fontSizePrint + 'px', 'page-break-inside': 'avoid' }">
                                                <tr>
                                                    <td style="border: none">
                                                        <span ref="pname" class="pname" style="white-space: nowrap">
                                                            {{ item.name }}
                                                            <i v-if="checkList.includes('职务')" :style="{fontSize: (5 * (parseInt(labelWidth) / 3 + parseInt(labelLong) / 10)) / 2 + 'px'}">{{ getZhiwu(item) }}</i>
                                                        </span>

                                                    </td>
                                                </tr>
                                            </tbody>
                                    </template>
                                    </table>
                                    <div v-if="dyzz==1" style="position: absolute;top: 50%;width: 210px;border-bottom: 1px dashed #7f7f7f60;transform: translateY(-50%);height: 0px;"></div>
                                    <div v-if="dyzz==2" style="position: absolute;top: 50%;width: 297px;border-bottom: 1px dashed #7f7f7f60;transform: translateY(-50%);height: 0px;"></div>
                                    <div v-if="dyzz==2" style="position: absolute;top:0;left: 50%;width: 0;height: 420px;border-left: 1px dashed #7f7f7f60;transform: translateX(-50%);"></div>
                                </div>
                            </td>
                        </tr>
                        <!-- <tr>
                            <td v-text-lbl="'width'" align="right" class="tdBg" style="width: 50px; text-align: center">宽</td>
                            <td>
                                <el-input v-model="labelWidth" type="number" placeholder="" autocomplete="off" @change="lableSizeChange">
                                    <template slot="append">cm</template>
                                </el-input>
                            </td>
                        </tr> -->
                    </table>
                </div>
                <!-- <div class="pright" :style="{height:printHeight}"> -->
                <div class="pright">
                    <!-- <div v-pageBtn-lbl="'preview'" class="ptitle" style="padding-left: 30px">预 览</div> -->
                    <div :style="{'height':dyzz===1?'532px':'654px'}" style="overflow: hidden;display: flex;">
                        <!-- <div ref="A4" class="A4"> -->
                        <!-- <div ref="A4Inner" :class="dyzz===1?'A4Inner':'A3Inner'">
                            <table style="margin: unset; width: 100%; display: flex; flex-wrap: wrap; justify-content: space-around; align-content: start">
                               <template v-for="(item,index) in realSeatArr">
                                    <tbody v-if="index<viewPageSize" :key="item" class="labelTag" style="border: 1px solid #ddd; display: flex; align-items: center; justify-content: center; margin: 5px 0; font-weight: bold; letter-spacing: 2px" :style="{ width: labelLongM, height: labelWidthM, fontSize: (13 * (parseInt(labelWidth) / 3 + parseInt(labelLong) / 10)) / 2 + 'px', 'page-break-inside': 'avoid' }">
                                        <tr>
                                            <td style="border: none">
                                                <span ref="pname" class="pname" style="white-space: nowrap">
                                                    {{ item.name }}
                                                    <i v-if="checkList.includes('职务')" :style="{fontSize: (6 * (parseInt(labelWidth) / 3 + parseInt(labelLong) / 10)) / 2 + 'px'}">设计总监</i>
                                                </span>

                                            </td>
                                        </tr>
                                    </tbody>
                               </template>
                            </table>

                        </div> -->

                        <div class="right diaRight" style="border-bottom: 0px;height: fit-content;">
                            <div :style="{'height':dyzz===1?'532px':'654px'}" style="width: 88px;">
                                <div style="line-height: 39px;border-bottom: 1px solid #ddd;text-align: center;">打印范围</div>
                                <div style="line-height: 40px;text-align: center;">人员清单</div>
                            </div>
                            <div style="flex: 1;">
                                <div v-text-lbl="'meetinger'" style="border-left: 1px solid #ddd;" class="title">
                                    <el-radio-group v-model="isPirn" @input="isPirnChange">
                                        <el-radio :label="1">全体参会人员</el-radio>
                                        <el-radio :label="2">指定人员</el-radio>
                                    </el-radio-group>
                                </div>
                                <div v-if="showPerson" style="border-left: 1px solid #ddd;">
                                    <span v-field-lbl="'attendLeader'" style="display: inline-block;padding: 15px 15px 0 15px;">出席领导 ：</span>
                                    <div class="seatType">

                                        <template v-if="leaderList.length > 0">
                                            <template v-if="!isDel">
                                                <div v-for="(item,index) in leaderList" :key="index" class="humanBlock" :class="{ cursorPdrag: realSeatFn(item) }" @click="personClick(item)">{{ item.name }}</div>
                                            </template>
                                        </template>
                                    </div>
                                    <span v-field-lbl="'meetHost'" style="display: inline-block;padding: 15px 15px 0 15px;">会议主持人：</span>
                                    <div class="seatType">
                                        <!-- <span v-field-lbl="'meetHost'">会议主持人：</span> -->
                                        <template v-if="hostList.length > 0">
                                            <template v-if="!isDel">
                                                <div v-for="(item,index) in hostList" :key="index" class="humanBlock" :class="{ cursorPdrag: realSeatFn(item) }" @click="personClick(item)">{{ item.name }}</div>
                                            </template>
                                        </template>
                                    </div>
                                    <span v-field-lbl="'summaryName'" style="display: inline-block;padding: 15px 15px 0 15px;">会议纪要人员：</span>
                                    <div class="seatType">
                                        <!-- <span v-field-lbl="'summaryName'">会议纪要人员：</span> -->
                                        <template v-if="summaryList.length > 0">
                                            <template v-if="!isDel">
                                                <div v-for="(item,index) in summaryList" :key="index" class="humanBlock" :class="{ cursorPdrag: realSeatFn(item) }" @click="personClick(item)">{{ item.name }}</div>
                                            </template>
                                        </template>
                                    </div>
                                    <span v-field-lbl="'participants'" style="display: inline-block;padding: 15px 15px 0 15px;">参会人员：</span>
                                    <div class="seatType">
                                        <!-- <span v-field-lbl="'participants'">参会人员：</span> -->
                                        <template v-if="otherList.length > 0">
                                            <template v-if="!isDel">
                                                <div v-for="(item,index) in otherList" :key="index" class="humanBlock" :class="{ cursorPdrag: realSeatFn(item) }" @click="personClick(item)">{{ item.name }}</div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div style="position: fixed;left: -2000%;z-index: -1;">
                            <div id="A4Inner" ref="A4Inner" style="position: relative;" :class="dyzz===1?'A4Inner':'A3Inner'">
                                <table style="margin: unset; width: 100%; display: flex; flex-wrap: wrap; ">
                                    <tbody v-for="(item,index) in realSeatArr" :key="index" class="labelTag" style="overflow: hidden;border: 0px;display: flex; align-items: center; justify-content: center; margin: 0px; font-weight: bold; letter-spacing: 2px" :style="{ width: labelLongM, height: labelWidthM, fontSize: fontSizePrint + 'px', 'page-break-inside': 'avoid' }">
                                        <tr>
                                            <td :style="{'transform':dyzz===1?'none':'rotate(90deg)'}" style="border: none">
                                                <span ref="pname" class="pname" style="white-space: nowrap">{{ item.name }}</span>
                                                <i v-if="checkList.includes('职务')" style="padding-left: 10px;" :style="{fontSize: (5 * (parseInt(labelWidth) / 3 + parseInt(labelLong) / 10)) / 2 + 'px'}">{{ getZhiwu(item) }}</i>
                                            </td>
                                        </tr>
                                        <div v-if="index===0&&dyzz==1" style="position: fixed;top: 50%;width: 100%;border-bottom: 1px dashed #7f7f7f60;transform: translateY(-50%);height: 0px;"></div>
                                        <div v-if="index===0&&dyzz==2" style="position: fixed;top: 50%;width: 100%;border-bottom: 1px dashed #7f7f7f60;transform: translateY(-50%);height: 0px;"></div>
                                        <div v-if="index===0&&dyzz==2" style="position: fixed;top:0;left: 50%;width: 0;height: 100%;border-left: 1px dashed #7f7f7f60;transform: translateX(-50%);"></div>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-pageBtn-lbl="'cancel'" :disabled="printDisabled" @click="isShow = false">取消</el-button>
                <el-button v-pageBtn-lbl="'print'" type="primary" :disabled="printDisabled" @click="toPrint">打印</el-button>
                <!-- <el-button v-print="'#A4Inner' + meetLayout.uId" type="primary" :disabled="printDisabled">打 印</el-button> -->
                <!-- <el-button v-print="'#A4Inner'" type="primary" :disabled="printDisabled">打 印</el-button> -->
            </span>
        </el-dialog>
    </div>
</template>

<script>
import $ from 'jquery'

import imgUrl from './images/remove.png'
import html2canvas from 'html2canvas'
export default {
    filters: {},
    components: {},
    props: {
        row: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'components',
            leftHeight: '',
            printDisabled: false,
            queryParam: {}, // 我组织的列表页面携带过来的参数
            leaderList: [], // 参会领导
            hostList: [], // 主持人
            summaryList: [], // 会议纪要人员
            otherList: [], // 参会人员
            dialogTitle: '',
            isShow: false,
            printCont: null,
            meetingRoomVo: {}, // 会议室详情数据
            meetLayout: {}, // 会议室布局数据
            meetingDetailVo: {}, // 会议人员详情数据
            doing: false,
            totalList: [], // 所有参加会议的人员集合（去重之后的）
            actTotal: null, // 真实座位个数
            isDel: true, // 局部刷新用
            // dragId: '' // 拖拽对调换时候用来存放被拖拽对象的id
            newSeat: true, // 是否是座位之间对调
            dataURL: '',
            printType: '', // 打印类型
            printHeight: '',
            labelLong: 19,
            labelWidth: 8,
            labelLongM: '190px', // 单位毫米
            labelWidthM: '80px', // 单位毫米
            realSeatArr: [], // 真实被排在座位上的人员
            checkList: ['姓名'],
            dyzz: 1,
            viewPageSize: 3, //每页多少个标签
            viewPageNum: 1,
            isPirn: 1,
            allPerson: [],
            showPerson: true,
            personData: [],
            fontSizePrint: '38'
        }
    },
    computed: {},
    watch: {},
    created() {
        this.isDel = true
    },
    beforeDestroy() {
        this.isDel = true
    },
    mounted() {
        // $('body').css({
        //     'overflow-y': 'unset'
        // })
        this.queryParam = this.$route.query

        this.getMeet(this.row.id)
        var _this = this
        _this.isDel = true
        this.$nextTick(() => {
            setTimeout(() => {
                _this.isDel = false
            }, 500)
        })
        this.getPersonData()
    },
    methods: {
        seatSelectBtn() {
            window.open(`#/seatSelect?rowId=${this.row.id}&meetingId=${this.row.meetPlaceId}`)
        },
        dyzzChange(val) {
            if (val === 2) {
                this.labelLong = 28
                this.labelWidth = 9
            } else {
                this.labelLong = 19
                this.labelWidth = 8
            }
            this.lableSizeChange()
        },
        getZhiwu(val) {
            let str = ''
            if (val.personId) {
                this.personData.forEach(item => {
                    if (val.personId === item.personId) {
                        str = item.positionName
                    }
                })
            } else {
                this.personData.forEach(item => {
                    if (val.name === item.name) {
                        str = item.positionName
                    }
                })
            }
            return str
        },
        getPersonData() {
            this.$http({
                url: 'base/organMgr/findOrganPersonByOrgCode',
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: { orgCode: this.$store.getters.loginUser.orgCode, self: false }
            }).then((res) => {
                if (res.code === 'success') {
                    this.personData = res.body.listdata
                }
            })
        },
        NoberFn(val) {
            if (val === 1) {
                console.log('val', val)
                $('.left').html(unescape(this.meetLayout.seatHtml))
                this.autoSetSeat()
                this.isDel = !this.isDel
                this.$nextTick(() => {
                    this.isDel = !this.isDel
                })
                setTimeout(() => {
                    this.intialMethod()
                }, 200)
            } else if (val === 2) {
                console.log('val', val)
                $('.left').html(unescape(this.meetLayout.seatHtml))
                this.isDel = !this.isDel
                this.$nextTick(() => {
                    this.isDel = !this.isDel
                })
                setTimeout(() => {
                    this.intialMethod()
                }, 200)
            }
        },
        // 座位中是否对当前人已经排座
        filterName(val) {
            var isHave = false
            $('.peopleSeat').each((i, item) => {
                if (item.innerText === val) {
                    isHave = true
                    return
                }
            })
            if (isHave) {
                return true
            } else {
                return false
            }
        },
        // 会议人员详情
        getMeet(id) {
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    id: id
                },
                url: '/hygl/hyap/getById'
            }).then(
                (res) => {
                    if (res.code === 'success') {
                        this.meetingDetailVo = res.body.vo
                        this.leaderList = []
                        this.hostList = []
                        this.summaryList = []
                        this.otherList = []
                        // 主持人 meetHost // 出席领导 attendLeader // 会议纪要人员 summaryName // 参会人员 attendName

                        // 处理出席领导
                        if (res.body.vo.attendLeader) {
                            const leader = this.replaceAll(res.body.vo.attendLeader)
                            const ids = res.body.vo.attendLeaderId.split(',')
                            const leaderList = leader.split('-')
                            for (var i = 0; i < leaderList.length; i++) {
                                var arrOne = {
                                    id: i + 'L',
                                    name: leaderList[i],
                                    personId: ids[i]
                                }
                                this.leaderList.push(arrOne)
                            }
                        }
                        // 处理主持人
                        if (res.body.vo.meetHost) {
                            this.hostList = [{ id: 'host', name: res.body.vo.meetHost, personId: res.body.vo.meetHostId}]
                        }
                        // 处理会议纪要人员
                        if (res.body.vo.summaryName) {
                            this.summaryList = [{ id: 'summary', name: res.body.vo.summaryName, personId: res.body.vo.summaryId }]
                        }
                        // 处理参会人员
                        if (res.body.vo.meetShape === 1) {
                            // 参会形式为参会人员
                            const otherList = res.body.vo.attendName.split('、')
                            const ids = res.body.vo.attendLeaderId.split(',')
                            for (var j = 0; j < otherList.length; j++) {
                                var arrTwo = {
                                    id: j + 'O',
                                    name: otherList[j],
                                    personId: ids[j]
                                }
                                this.otherList.push(arrTwo)
                            }
                        } else if (res.body.vo.meetShape === 2) {
                            // 参会形式为参会部门
                            // this.getOthers(this.row.id)
                        }

                        // 综合所有会议人员进行去重
                        this.totalList = this.leaderList.concat(this.hostList, this.summaryList, this.otherList)
                        this.totalList = this.hasOne(this.totalList)

                        // 获取会议室详情，得到真实座位数目
                        this.getMeetDetail(this.row.meetPlaceId)
                        if (this.meetingDetailVo.meetRowSeat) {
                            // 已经排座
                            // this.$refs.enterDivWrap.innerHTML = unescape(this.meetingDetailVo.meetRowSeat)
                            $('.left').append(unescape(this.meetingDetailVo.meetRowSeat))
                        }
                        var _this = this
                        $('.enterDiv').on('mouseenter', 'div.peopleSeat', function () {
                            var img = document.createElement('img')
                            img.setAttribute('id', 'peopleDel')
                            img.style.position = 'absolute'
                            img.style.width = '20px'
                            img.style.height = '20px'
                            img.style.right = '0'
                            img.style.top = '10px'
                            img.src = imgUrl
                            // $(this).append(img)
                        })
                        // 鼠标离开小图标消失
                        $('.enterDiv').on('mouseleave', 'div.peopleSeat', function () {
                            $('#peopleDel').remove()
                        })
                        // 节点小图标的单击事件
                        $('.enterDiv').on('click', '#peopleDel', function () {
                            _this.isDel = true
                            $(this).parent().remove()
                            setTimeout(() => {
                                _this.isDel = false
                                _this.$nextTick(() => {
                                    _this.intialMethod()
                                })
                            }, 200)
                        })
                        setTimeout(() => {
                            _this.intialMethod()
                        }, 2000)
                    } else {
                        // this.$message({
                        //     message: res.message,
                        //     type: 'warning'
                        // })
                    }
                },
                (err) => {
                    this.$message.error(err)
                }
            )
        },
        // 参会人员数据
        getOthers(id) {
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                // params: {
                //     id: id
                // },
                url: '/hygl/hyap/getNameList?id=' + id
            }).then(
                (res) => {
                    if (res.code === 'success') {
                        const otherList = res.body.json.namelist
                        for (var j = 0; j < otherList.length; j++) {
                            var arrTwo = {
                                id: j + 'O',
                                name: otherList[j]
                            }
                            this.otherList.push(arrTwo)
                        }
                        console.log('this.otherList', this.otherList)
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        })
                    }
                },
                (err) => {
                    this.$message.error(err)
                }
            )
        },
        // 根据会议室id获取会议室详情
        getMeetDetail(id) {
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    id: id
                },
                url: '/hygl/meetingRoom/getById'
            }).then(
                (res) => {
                    if (res.code === 'success') {
                        this.meetingRoomVo = res.body.vo
                        this.meetLayout = JSON.parse(res.body.vo.meetLayout)
                        var meetLayout = JSON.parse(res.body.vo.meetLayout)

                        if (meetLayout.deskType === 'circle') {
                            $('.enterDiv').css({
                                margin: '0 150px 150px'
                            })
                            this.actTotal = parseInt(meetLayout.circleSeat)
                        } else if (meetLayout.deskType === 'big') {
                            $('.enterDiv').css({
                                margin: '0 200px 150px'
                            })
                            this.actTotal = parseInt(meetLayout.bigTotal)
                        } else if (meetLayout.deskType === 'rect' || meetLayout.deskType === 'utype') {
                            this.actTotal = parseInt(meetLayout.rectTotal)
                        }
                        if (!this.meetingDetailVo.meetRowSeat) {
                            // 没有排座
                            $('.left').append(unescape(meetLayout.seatHtml))
                            this.autoSetSeat()
                        }
                    }
                },
                (err) => {
                    this.$message.error(err)
                }
            )
        },
        // 自动排座
        autoSetSeat() {
            // 先知道当前桌子类型, 如果是U型或者长方形桌子
            const deskType = this.meetLayout.deskType
            if (deskType === 'utype' || deskType === 'rect' || deskType === 'circle') {
                // 长型桌子，
                // 一、判断若有真实短边个数，
                // 获取短边真实个数，先判断奇偶，
                // 奇数除以2的则为中间领导位置的索引值，
                // 若为偶数，除以2再减一即为中间的索引值
                // 二、若没有，面对门的为领导坐的

                var leadSumList = this.leaderList.concat(this.hostList, this.summaryList)
                leadSumList = this.hasOne(leadSumList)
                if (deskType === 'utype' || deskType === 'rect') {
                    this.meetLayout.realShortSeat = parseInt(this.meetLayout.realShortSeat)
                    if (this.meetLayout.realShortSeat) {
                        // 短边桌有坐席 不管门的位置
                        if (leadSumList.length > 0) {
                            // 如果有领导或会议主持人，或会议纪要
                            if (leadSumList.length <= this.meetLayout.realShortSeat) {
                                // 人员在短坐席可以做的下
                                var isEven = this.isEven(this.meetLayout.realShortSeat) // 判断是否是偶数
                                var median // 中间索引值
                                if (isEven) {
                                    // 偶数
                                    median = parseInt(this.meetLayout.realShortSeat / 2) - 1
                                } else {
                                    // 奇数
                                    median = parseInt(this.meetLayout.realShortSeat / 2)
                                }

                                var absArr = [] // 绝对值数组
                                var abs
                                $("div[type='short']").each((i, element) => {
                                    abs = Math.abs(median - (parseInt(element.innerText) - 1)) // 距离中间值的距离
                                    // 思想就是，算出距离中间值的距离之后，对比左右距离大小，对比距离大小之前先记住这些数值之前的索引
                                    absArr.push({
                                        value: abs,
                                        oindex: parseInt(element.innerText) - 1 // 在页面里面类后面的索引，id后面的索引
                                    })
                                })

                                absArr.sort(this.sortNumber) // 排序是为了让this.leaderList按照页面上展示的先后顺序排座
                                absArr.forEach((item, i) => {
                                    // $("div[type='short']")[item.oindex].innerHTML += '<div>' + leadSumList[i].name + '</div>'
                                    if (leadSumList[i]) {
                                        $('#imgSeat-' + item.oindex)[0].innerHTML += '<div class="peopleSeat">' + leadSumList[i].name + '</div>'
                                    }
                                })

                                // 处理剩余参会人员
                                var allList = leadSumList.concat(this.otherList)
                                allList = this.hasOne(allList)
                                var allListOne = []
                                // for (var i = 0; i < allList.length; i++) {
                                //     if (leadSumList.indexOf(allList[i]) === -1) {
                                //         allListOne.push(allList[i])
                                //     }
                                // }

                                for (var i = 0; i < allList.length; i++) {
                                    var obj = allList[i]
                                    var name = obj.name
                                    var isExist = false
                                    for (var j = 0; j < leadSumList.length; j++) {
                                        var aj = leadSumList[j]
                                        var n = aj.name
                                        if (n === name) {
                                            isExist = true
                                            break
                                        }
                                    }
                                    if (!isExist) {
                                        allListOne.push(obj)
                                    }
                                }

                                var absArrOther2 = [] // 绝对值数组
                                var btmStart2 = parseInt($("div[type='long']")[0].innerText) + parseInt(this.meetLayout.realLongSeat / 2) + parseInt(this.meetLayout.realLongSeat % 2) // 长形或u型底边的起始值
                                var absOther2
                                $("div[type='long']").each((i, element) => {
                                    if (parseInt(element.innerText) < btmStart2) {
                                        // 顶边座位
                                        absOther2 = Math.abs(parseInt(element.innerText) - this.meetLayout.realShortSeat) // 距离领导桌的距离
                                    } else if (parseInt(element.innerText) >= btmStart2) {
                                        // 底边座位
                                        absOther2 = Math.abs(parseInt(element.innerText) - parseInt(this.meetLayout.realLongSeat / 2) - parseInt(this.meetLayout.realLongSeat % 2) - this.meetLayout.realShortSeat) // 距离领导桌的距离
                                    }
                                    // 思想就是，算出距离中间值的距离之后，对比左右距离大小，对比距离大小之前先记住这些数值之前的索引
                                    absArrOther2.push({
                                        value: absOther2,
                                        oindex: parseInt(element.innerText) - 1 // 在页面里面类后面的索引，id后面的索引
                                    })
                                })

                                absArrOther2.sort(this.sortNumber) // 排序是为了让this.leaderList按照页面上展示的先后顺序排座
                                absArrOther2.forEach((item, i) => {
                                    if (allListOne[i]) {
                                        $('#imgSeat-' + item.oindex)[0].innerHTML += '<div class="peopleSeat">' + allListOne[i].name + '</div>'
                                    }
                                })
                            } else {
                                // 领导或会议主持人，或会议纪要人员在短边坐不下
                                // 先处理坐的下的
                                var leadSumListCan = leadSumList.slice(0, this.meetLayout.realShortSeat)
                                var isEven2 = this.isEven(this.meetLayout.realShortSeat) // 判断是否是偶数
                                var median2 // 中间索引值
                                if (isEven2) {
                                    // 偶数
                                    median2 = parseInt(this.meetLayout.realShortSeat / 2) - 1
                                } else {
                                    // 奇数
                                    median2 = parseInt(this.meetLayout.realShortSeat / 2)
                                }

                                var absArr2 = [] // 绝对值数组
                                var abs2
                                $("div[type='short']").each((i, element) => {
                                    abs2 = Math.abs(median2 - (parseInt(element.innerText) - 1)) // 距离中间值的距离
                                    // 思想就是，算出距离中间值的距离之后，对比左右距离大小，对比距离大小之前先记住这些数值之前的索引
                                    absArr2.push({
                                        value: abs2,
                                        oindex: parseInt(element.innerText) - 1 // 在页面里面类后面的索引，id后面的索引
                                    })
                                })

                                absArr2.sort(this.sortNumber) // 排序是为了让this.leaderList按照页面上展示的先后顺序排座
                                absArr2.forEach((item, i) => {
                                    // $("div[type='short']")[item.oindex].innerHTML += '<div>' + leadSumListCan[i].name + '</div>'
                                    $('#imgSeat-' + item.oindex)[0].innerHTML += '<div class="peopleSeat">' + leadSumListCan[i].name + '</div>'
                                })
                                // 处理坐不下的
                                var allList2 = leadSumList.concat(this.otherList)
                                allList2 = this.hasOne(allList2) // 所有人员，所有人员去除掉短边的个数即为剩下所有人员
                                var exLeadNum = parseInt(this.meetLayout.realShortSeat) // 起始索引
                                var exLeadNew = allList2.slice(exLeadNum) // 与参会人员重新组合 exLeadNew坐不下的人员

                                var absArrOther = [] // 绝对值数组
                                var btmStart = parseInt($("div[type='long']")[0].innerText) + parseInt(this.meetLayout.realLongSeat / 2) + parseInt(this.meetLayout.realLongSeat % 2) // 长形或u型底边的起始值
                                var absOther
                                $("div[type='long']").each((i, element) => {
                                    if (parseInt(element.innerText) < btmStart) {
                                        // 顶边座位
                                        absOther = Math.abs(parseInt(element.innerText) - this.meetLayout.realShortSeat) // 距离领导桌的距离
                                    } else if (parseInt(element.innerText) >= btmStart) {
                                        // 底边座位
                                        absOther = Math.abs(parseInt(element.innerText) - parseInt(this.meetLayout.realLongSeat / 2) - parseInt(this.meetLayout.realLongSeat % 2) - this.meetLayout.realShortSeat) // 距离领导桌的距离
                                    }
                                    // 思想就是，算出距离中间值的距离之后，对比左右距离大小，对比距离大小之前先记住这些数值之前的索引
                                    absArrOther.push({
                                        value: absOther,
                                        oindex: parseInt(element.innerText) - 1 // 在页面里面类后面的索引，id后面的索引
                                    })
                                })

                                absArrOther.sort(this.sortNumber) // 排序是为了让this.leaderList按照页面上展示的先后顺序排座
                                absArrOther.forEach((item, i) => {
                                    if (exLeadNew[i]) {
                                        // $("div[type='long']")[item.oindex].innerHTML += '<div>' + exLeadNew[i].name + '</div>'
                                        $('#imgSeat-' + item.oindex)[0].innerHTML += '<div class="peopleSeat">' + exLeadNew[i].name + '</div>'
                                    }
                                })
                            }
                        } else {
                            // 只有参会人员，没有领导（随便排）
                            this.otherList = this.hasOne(this.otherList)
                            const _this = this
                            $('.imgSeat').each(function (i, item) {
                                if (_this.otherList[i]) {
                                    $(this).append('<div class="peopleSeat">' + _this.otherList[i].name + '</div>')
                                }
                                // 绑定座位与人的关系
                                // const idNum = $(this).attr('id').split('-')[1]
                                // this.otherList[i].seatNum = parseInt(idNum) + 1
                            })
                        }
                    } else {
                        // 短边桌没有坐席 需要知道门在哪里，领导应该做哪里
                        if (leadSumList.length > 0) {
                            if ($('.door')[0].style.top === '-10px') {
                                // 门在上面 底边的为A方上级领导
                                this.aisBtm(leadSumList)
                            } else if ($('.door')[0].style.right === '-10px' || $('.door')[0].style.left === '-10px') {
                                // 门在右边，离门远的为A方上级领导
                                const splitHeight = parseInt($('.divW')[0].style.height) / 2
                                if (parseInt($('.door')[0].style.top) > splitHeight) {
                                    // A方为上面的那条边
                                    this.aisTop(leadSumList)
                                } else {
                                    // A方为下面这条边
                                    this.aisBtm(leadSumList)
                                }
                            } else if ($('.door')[0].style.bottom === '-10px') {
                                // 门在下面，面对门的为A方上级领导
                                this.aisTop(leadSumList)
                            }
                        } else {
                            // 只有参会人员，没有领导（随便排）
                            this.otherList = this.hasOne(this.otherList)
                            const _this = this
                            $('.imgSeat').each(function (i, item) {
                                if (_this.otherList[i]) {
                                    $(this).append('<div class="peopleSeat">' + _this.otherList[i].name + '</div>')
                                }
                                // 绑定座位与人的关系
                                // const idNum = $(this).attr('id').split('-')[1]
                                // this.otherList[i].seatNum = parseInt(idNum) + 1
                            })
                        }
                    }
                } else if (deskType === 'circle') {
                    // 圆桌需要知道门在哪里，领导应该做哪里
                    var medianCir // 圆桌中间索引值
                    this.meetLayout.circleSeat = parseInt(this.meetLayout.circleSeat)
                    var absArrCir = [] // 绝对值数组
                    var absCir
                    var allListCir = leadSumList.concat(this.otherList)
                    allListCir = this.hasOne(allListCir)
                    if (this.meetLayout.doorAt === 'top') {
                        // 门在上边 领导在下边
                        medianCir = 1
                    } else if (this.meetLayout.doorAt === 'right') {
                        // 门在右边 领导在左边
                        medianCir = (parseInt(this.meetLayout.circleSeat / 2) + parseInt(this.meetLayout.circleSeat % 2) + 1) / 2
                    } else if (this.meetLayout.doorAt === 'bottom') {
                        // 门在下边 领导在上边
                        medianCir = parseInt(this.meetLayout.circleSeat / 2) + parseInt(this.meetLayout.circleSeat % 2)
                    } else if (this.meetLayout.doorAt === 'left') {
                        // 门在左边 领导在右边
                        // 中间值的算法为 (（总座位数/2) + （总座位数%2) + 总座位数)/2
                        medianCir = (parseInt(this.meetLayout.circleSeat / 2) + parseInt(this.meetLayout.circleSeat % 2) + this.meetLayout.circleSeat) / 2
                    }
                    $('.imgSeat').each((i, element) => {
                        absCir = Math.abs(medianCir - (parseInt(element.innerText) - 1)) // 距离中间值的距离
                        // 思想就是，算出距离中间值的距离之后，对比左右距离大小，对比距离大小之前先记住这些数值之前的索引
                        absArrCir.push({
                            value: absCir,
                            oindex: parseInt(element.innerText) - 1 // 在页面里面类后面的索引，id后面的索引
                        })
                    })
                    absArrCir.reverse()
                    absArrCir.sort(this.sortNumber)
                    absArrCir.forEach((item, i) => {
                        if (allListCir[i]) {
                            $('#imgSeat-' + item.oindex)[0].innerHTML += '<div class="peopleSeat">' + allListCir[i].name + '</div>'
                        }
                    })
                }
            } else if (deskType === 'big') {
                var idDesc = $('.enterDiv').attr('id')
                // 主席台排位置有出席领导，主持人，会议纪要人员
                var arrs = this.leaderList.concat(this.hostList, this.summaryList)
                arrs = this.hasOne(arrs)
                if (arrs.length > 0) {
                    // 有领导或，主持人，会议纪要人员
                    this.meetLayout.realBigLeadRowNum = parseInt(this.meetLayout.realBigLeadRowNum)
                    if (this.meetLayout.realBigLeadRowNum) {
                        // 如果有主席台
                        var l
                        var absArrBig = [] // 绝对值数组
                        var absBig
                        var isEvenBig
                        var medianBig // 中间索引值
                        if (arrs.length <= parseInt(this.meetLayout.realBigLeadRowNum)) {
                            // 主席台排能坐下
                            // 主席台从中间到两边进行排座
                            const bigLeadRows = parseInt(this.meetLayout.bigLeadRows)
                            // var l
                            // var absArrBig = [] // 绝对值数组
                            // var absBig
                            // var isEvenBig
                            // var medianBig // 中间索引值
                            for (var z = bigLeadRows - 1; z >= 0; z--) {
                                l = $('#lead' + z + idDesc)[0].children.length
                                if (l > 0) {
                                    isEvenBig = this.isEven(l) // 判断是否是偶数

                                    if (isEvenBig) {
                                        // 偶数
                                        medianBig = parseInt(l / 2) - 1
                                    } else {
                                        // 奇数
                                        medianBig = parseInt(l / 2)
                                    }
                                    var absArrBigCopy = [] // 当前行绝对值数组
                                    $('#lead' + z + idDesc)
                                        .children()
                                        .each((j, element) => {
                                            absBig = Math.abs(medianBig - (parseInt(element.innerText) - 1)) // 距离中间值的距离
                                            // 思想就是，算出距离中间值的距离之后，对比左右距离大小，对比距离大小之前先记住这些数值之前的索引
                                            absArrBigCopy.push({
                                                value: absBig,
                                                oindex: z + '-' + (parseInt(element.innerText) - 1) // 在页面里面类后面的索引，id后面的索引
                                            })
                                        })
                                    absArrBigCopy.sort(this.sortNumber)
                                    absArrBig = absArrBig.concat(absArrBigCopy)
                                }
                            }

                            absArrBig.forEach((item, i) => {
                                if (arrs[i]) {
                                    // $("div[type='long']")[item.oindex].innerHTML += '<div>' + arrs[i].name + '</div>'
                                    $('#imgSeat-L-' + item.oindex)[0].innerHTML += '<div class="peopleSeat">' + arrs[i].name + '</div>'
                                }
                            })
                            // 处理剩余参会人员
                            var allListBig2 = arrs.concat(this.otherList)
                            allListBig2 = this.hasOne(allListBig2)
                            var allListOneBig = []

                            for (var r = 0; r < allListBig2.length; r++) {
                                var objc = allListBig2[r]
                                var nam = objc.name
                                var isExist2 = false
                                for (var t = 0; t < arrs.length; t++) {
                                    var aj2 = arrs[t]
                                    var n2 = aj2.nam
                                    if (n2 === nam) {
                                        isExist2 = true
                                        break
                                    }
                                }
                                if (!isExist2) {
                                    allListOneBig.push(obj)
                                }
                            }

                            // 直接排位置
                            $('.imgSeatCus').each((i, item) => {
                                if (!allListOneBig[i]) {
                                    return false
                                }
                                item.innerHTML += '<div class="peopleSeat">' + allListOneBig[i].name + '</div>'
                                // $(this).append('<div>' + allListOneBig[i].name + '</div>')
                            })

                            // $('.imgSeatLead').each(function(i, item) {
                            //     if (!arrs[i]) {
                            //         return false
                            //     }
                            //     $(this).append('<div>' + arrs[i].name + '</div>')
                            //     // 绑定座位与人的关系
                            //     const idNum = $(this).attr('id').split('-')[2]
                            //     arrs[i].seatNum = parseInt(idNum) + 1
                            // })
                        } else {
                            // 主席台排坐不下
                            // 先处理坐的下的
                            var arrsCan = arrs.slice(0, this.meetLayout.realBigLeadRowNum)
                            const bigLeadRows = parseInt(this.meetLayout.bigLeadRows)
                            for (var f = bigLeadRows - 1; f >= 0; f--) {
                                l = $('#lead' + f + idDesc)[0].children.length
                                if (l > 0) {
                                    isEvenBig = this.isEven(l) // 判断是否是偶数

                                    if (isEvenBig) {
                                        // 偶数
                                        medianBig = parseInt(l / 2) - 1
                                    } else {
                                        // 奇数
                                        medianBig = parseInt(l / 2)
                                    }
                                    var absArrBigCopy2 = [] // 当前行绝对值数组
                                    $('#lead' + f + idDesc)
                                        .children()
                                        .each((j, element) => {
                                            absBig = Math.abs(medianBig - (parseInt(element.innerText) - 1)) // 距离中间值的距离
                                            // 思想就是，算出距离中间值的距离之后，对比左右距离大小，对比距离大小之前先记住这些数值之前的索引
                                            absArrBigCopy2.push({
                                                value: absBig,
                                                oindex: f + '-' + (parseInt(element.innerText) - 1) // 在页面里面类后面的索引，id后面的索引
                                            })
                                        })
                                    absArrBigCopy2.sort(this.sortNumber)
                                    absArrBig = absArrBig.concat(absArrBigCopy2)
                                }
                            }
                            absArrBig.forEach((item, i) => {
                                if (arrsCan[i]) {
                                    $('#imgSeat-L-' + item.oindex)[0].innerHTML += '<div class="peopleSeat">' + arrsCan[i].name + '</div>'
                                }
                            })

                            // 处理坐不下的
                            var allListBig = arrs.concat(this.otherList)
                            allListBig = this.hasOne(allListBig)
                            var exLeadNumBig = parseInt(this.meetLayout.realBigLeadRowNum) // 起始索引
                            var exLeadBigNew = allListBig.slice(exLeadNumBig) // 与参会人员重新组合
                            // 直接排位置
                            $('.imgSeatCus').each((i, item) => {
                                if (!exLeadBigNew[i]) {
                                    return false
                                }
                                item.innerHTML += '<div class="peopleSeat">' + exLeadBigNew[i].name + '</div>'
                            })
                        }
                    } else {
                        // 如果没有主席台 直接排
                        var allBig = arrs.concat(this.otherList)
                        allBig = this.hasOne(allBig)
                        // 直接排位置
                        $('.imgSeatCus').each((i, item) => {
                            if (!allBig[i]) {
                                return false
                            }
                            item.innerHTML += '<div class="peopleSeat">' + allBig[i].name + '</div>'
                        })
                    }
                } else {
                    // 没有领导或，主持人，会议纪要人员
                    this.otherList = this.hasOne(this.otherList)
                    // 直接排位置
                    $('.imgSeatCus').each((i, item) => {
                        if (!this.otherList[i]) {
                            return false
                        }
                        item.innerHTML += '<div class="peopleSeat">' + this.otherList[i].name + '</div>'
                    })
                }
            }
            var _this = this
            $('.enterDiv').on('mouseenter', 'div.peopleSeat', function () {
                var img = document.createElement('img')
                img.setAttribute('id', 'peopleDel')
                img.style.position = 'absolute'
                img.style.width = '20px'
                img.style.height = '20px'
                img.style.right = '0'
                img.style.top = '10px'
                img.src = imgUrl
                // $(this).append(img)
            })
            // 鼠标离开小图标消失
            $('.enterDiv').on('mouseleave', 'div.peopleSeat', function () {
                $('#peopleDel').remove()
            })
            // 节点小图标的单击事件
            $('.enterDiv').on('click', '#peopleDel', function () {
                _this.isDel = true
                $(this).parent().remove()
                setTimeout(() => {
                    _this.isDel = false
                    _this.$nextTick(() => {
                        _this.intialMethod()
                    })
                }, 200)
            })
            this.intialMethod()
        },

        intialMethod() {

        },

        // 替换特殊字符为空格
        replaceAll(value) {
            var reg = /\\|\/|\?|\？|\*|\"|\“|\”|\'|\‘|\’|\<|\>|\{|\}|\[|\]|\【|\】|\：|\:|\、|\，|\^|\$|\!|\~|\`|\|/g
            var temp = value.replace(reg, '-')
            return temp
        },
        // 判断奇偶
        isEven(num) {
            if (num % 2 === 0) {
                // 偶数
                return true
            } else {
                return false
            }
        },
        // 判断某个id的网页元素是否存在
        existId(id) {
            if ($('#' + id).length > 0) {
                return true
            } else {
                return false
            }
        },
        // 去重
        hasOne(arr) {
            for (var i = 0; i < arr.length - 1; i++) {
                for (var j = i + 1; j < arr.length; j++) {
                    if (arr[i].name === arr[j].name) {
                        arr.splice(j, 1)
                        // 因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
                        j--
                    }
                }
            }
            return arr
        },
        // 获取最小值
        getMin(arr) {
            var min = arr[0]
            for (var i = 0; i < arr.length; i++) {
                if (min > arr[i]) {
                    min = arr[i]
                }
            }

            return min
        },
        // 获取最小值的下标
        // （最小值）有重复项时，返回的index值为数组中第一个（最小值）的下标
        getMinIndex(arr) {
            var min = arr[0]
            // 声明了个变量 保存下标值
            var index = 0
            for (var i = 0; i < arr.length; i++) {
                if (min > arr[i]) {
                    min = arr[i]
                    index = i
                }
            }
            return index
        },
        // 排序
        sortNumber(a, b) {
            return a.value - b.value
        },

        aisBtm(leadSumList) {
            // 算出底边开始索引与结束索引
            var endIndex = parseInt(this.meetLayout.realLongSeat / 2) + parseInt(this.meetLayout.realLongSeat % 2) // 底边总个数
            var isEven3 = this.isEven(endIndex) // 判断是否是偶数
            var median3 // 中间索引值
            if (isEven3) {
                // 偶数
                // median3 = parseInt(this.meetLayout.realLongSeat / 2) - 1
                median3 = parseInt(endIndex / 2) - 1
            } else {
                // 奇数
                // median3 = parseInt(this.meetLayout.realLongSeat / 2)
                median3 = parseInt(endIndex / 2)
            }

            var absArr3 = [] // 绝对值数组
            var abs3
            for (var k = 0; k < endIndex; k++) {
                abs3 = Math.abs(median3 - (parseInt($('#imgSeat-' + k)[0].innerText) - 1)) // 距离中间值的距离
                // 思想就是，算出距离中间值的距离之后，对比左右距离大小，对比距离大小之前先记住这些数值之前的索引
                absArr3.push({
                    value: abs3,
                    oindex: parseInt($('#imgSeat-' + k)[0].innerText) - 1 // 在页面里面类后面的索引，id后面的索引
                })
            }

            absArr3.sort(this.sortNumber) // 排序是为了让this.leaderList按照页面上展示的先后顺序排座
            var topArr = [] // 顶边数组
            for (var m = endIndex; m < this.meetLayout.realLongSeat; m++) {
                topArr.push({
                    oindex: m // 在页面里面类后面的索引，id后面的索引
                })
            }
            var newArr = absArr3.concat(topArr) // 只排领导座位，其余随便排
            var all = leadSumList.concat(this.otherList)
            all = this.hasOne(all)
            newArr.forEach((item, i) => {
                if (all[i]) {
                    $('#imgSeat-' + item.oindex)[0].innerHTML += '<div class="peopleSeat">' + all[i].name + '</div>'
                }
            })
        },
        aisTop(leadSumList) {
            // 算出底边开始索引与结束索引
            var endIndex = parseInt(this.meetLayout.realLongSeat / 2) + parseInt(this.meetLayout.realLongSeat % 2) // 底边总个数
            var isEven3 = this.isEven(parseInt(this.meetLayout.realLongSeat) - endIndex) // 判断是否是偶数
            var median3 // 中间索引值
            if (isEven3) {
                // 偶数
                median3 = parseInt((parseInt(this.meetLayout.realLongSeat) - endIndex) / 2) - 1
            } else {
                // 奇数
                median3 = parseInt((parseInt(this.meetLayout.realLongSeat) - endIndex) / 2)
            }

            var absArr3 = [] // 绝对值数组
            var abs3
            for (var k = endIndex; k < this.meetLayout.realLongSeat; k++) {
                abs3 = Math.abs(median3 - (parseInt($('#imgSeat-' + k)[0].innerText) - 1)) // 距离中间值的距离
                // 思想就是，算出距离中间值的距离之后，对比左右距离大小，对比距离大小之前先记住这些数值之前的索引
                absArr3.push({
                    value: abs3,
                    oindex: parseInt($('#imgSeat-' + k)[0].innerText) - 1 // 在页面里面类后面的索引，id后面的索引
                })
            }

            absArr3.sort(this.sortNumber) // 排序是为了让this.leaderList按照页面上展示的先后顺序排座
            var topArr = [] // 底边数组
            for (var m = 0; m < endIndex; m++) {
                topArr.push({
                    oindex: m // 在页面里面类后面的索引，id后面的索引
                })
            }
            var newArr = absArr3.concat(topArr) // 只排领导座位，其余随便排
            var all = leadSumList.concat(this.otherList)
            all = this.hasOne(all)
            newArr.forEach((item, i) => {
                if (all[i]) {
                    $('#imgSeat-' + item.oindex)[0].innerHTML += '<div class="peopleSeat">' + all[i].name + '</div>'
                }
            })
        },

        closeSeat() {
            setTimeout(() => {
                window.close()
                // 关闭页面
            }, 10)
        },

        // 保存座位
        async saveSeat() {
            this.doing = true
            this.meetingDetailVo.meetRowSeat = escape($('.enterDiv')[0].outerHTML)
            // this.meetingDetailVo.meetRowSeat = ''
            console.log('this.meetingDetailVo', this.meetingDetailVo)
            let resp = null
            resp = await this.$app.update('hygl/hyap/update', this.meetingDetailVo)
            if (resp.code === 'success') {
                this.doing = false
                this.$message.success(resp.message)
                // setTimeout(() => {
                //     window.close()
                //     // 关闭页面
                // }, 10)
            } else {
                this.doing = false
                this.$alert(resp.message, '错误', { type: 'error' })
            }
        },

        lableSizeChange() {
            // this.labelLongM = this.labelLong * 10 + 'px'
            // this.labelWidthM = this.labelWidth * 10 + 'px'

            if (this.dyzz === 1) {
                this.labelLongM = '210px'
                this.labelWidthM = (297 / 2) + 'px'
                let rowNum = Math.floor(210 / (Number(this.labelLongM.replace('px', ''))))
                let cloumnNum = Math.floor(297 / (Number(this.labelWidthM.replace('px', '')) + 10))
                this.viewPageSize = rowNum * cloumnNum
                this.viewPageNum = Math.ceil(this.realSeatArr.length / this.viewPageSize)
                console.log('viewPageSize', this.viewPageSize)
                console.log('viewPageNum', this.viewPageNum)
            }
            if (this.dyzz === 2) {
                this.labelLongM = (297 / 2) + 'px'
                this.labelWidthM = (420 / 2) + 'px'
                let rowNum = Math.floor(297 / (Number(this.labelLongM.replace('px', ''))))
                let cloumnNum = Math.floor(420 / (Number(this.labelWidthM.replace('px', '')) + 10))
                this.viewPageSize = rowNum * cloumnNum
                this.viewPageNum = Math.ceil(this.realSeatArr.length / this.viewPageSize)
                console.log('viewPageSize', this.viewPageSize)
                console.log('viewPageNum', this.viewPageNum)
            }
            var _this = this
            this.$nextTick(() => {
                $('.labelTag span').each(function (i, item) {
                    var index = $(this).attr('style').indexOf('font-size')
                    if (index > -1) {
                        // 说明有文字多的情况，特殊处理了字体大小
                        const oldSize = parseInt(_this.realSeatArr[i].oldSize)
                        item.style.fontSize = oldSize * (parseInt(item.parentNode.style.fontSize) / 14) + 'px'
                    }
                })
            })
        },
        isPirnChange(val) {
            this.showPerson = false
            if (val === 1) {
                this.realSeatArr = JSON.parse(JSON.stringify(this.allPerson))
            } else {
                this.realSeatArr = []
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    this.showPerson = true
                }, 200)
            })
        },
        realSeatFn(val) {
            let flang = false

            for (let i = 0; i < this.realSeatArr.length; i++) {
                let item = this.realSeatArr[i]
                if (item.name === val.name) {
                    flang = true
                }
            }
            return flang
        },
        personClick(val) {
            let flang = false
            for (let i = 0; i < this.realSeatArr.length; i++) {
                let item = this.realSeatArr[i]
                if (item.name === val.name) {
                    flang = true
                }
            }
            if (flang) {
                for (let i = 0; i < this.realSeatArr.length; i++) {
                    let item = this.realSeatArr[i]
                    if (item.name === val.name) {
                        this.realSeatArr.splice(i, 1)
                        return
                    }
                }
            } else {
                this.realSeatArr.push(val)
            }
        },
        // 坐席人员标签打印
        print(type) {
            console.log('1', this.leaderList)
            console.log('2', this.hostList)
            console.log('3', this.summaryList)
            console.log('4', this.otherList)
            this.printType = type
            this.dialogTitle = type === 'pic' ? '会议室平面图打印' : '坐席人员标签打印'
            this.isShow = true
            if (type === 'people') {
                this.allPerson = [...this.leaderList, ...this.hostList, ...this.summaryList, ...this.otherList]
                // this.labelLong = 19
                // this.labelWidth = 8
                // this.labelLongM = '190px' // 单位毫米
                // this.labelWidthM = '80px' // 单位毫米
                this.labelLongM = '210px'
                this.labelWidthM = (297 / 2) + 'px'
                this.dyzz = 1
                this.realSeatArr = []
                this.realSeatArr = JSON.parse(JSON.stringify(this.allPerson))
                this.printHeight = $(window).height() - 320 + 'px'
                // $('.peopleSeat').each((i, item) => {
                //     this.realSeatArr.push({
                //         name: item.innerText
                //     })
                // })
                this.$nextTick(() => {
                    $('.labelTag span').each((i, item) => {
                        if (parseInt(item.clientWidth) > parseInt(this.labelLongM)) {
                            var n = parseInt(item.clientWidth) / parseInt(this.labelLongM)
                            item.style.fontSize = parseInt(item.parentNode.style.fontSize) / n + 'px'
                            item.style.letterSpacing = 0
                            this.realSeatArr[i].oldSize = item.style.fontSize
                        }
                    })
                })
            } else {
                this.$nextTick(() => {
                    this.printPic()
                })
            }
        },
        // 预览平面图
        printPic() {
            const enterDiv = $('.enterDiv')[0]
            const { offsetWidth, offsetHeight, innerHTML } = enterDiv
            const previewDialogPicJQ = $('.preview_dialog_pic')
            const scale = previewDialogPicJQ[0].offsetWidth / offsetWidth
            previewDialogPicJQ.css({ height: offsetHeight * scale })
            $('.preview_dialog_pic_scale').css({ zoom: scale })
            this.printCont = innerHTML
            if (this.meetLayout.deskType === 'utype' || this.meetLayout.deskType === 'rect') {
                $('.enterDiv').css({
                    margin: '0 50px !important'
                })
            }
            const h = parseInt($('.enterDiv .divW')[0].style.height) + 20 + 'px'
            this.$nextTick(() => {
                $('.printCont').css('height', h)
            })
        },
        toPrint() {
            this.printDisabled = true // 点击打印按钮禁止重复点击
            var _this = this
            if (this.printType === 'pic') {
                const enterDiv = $('.enterDiv')[0]
                const { offsetWidth, offsetHeight } = enterDiv
                let imgMaxWidth = '100%'
                if (offsetHeight * 0.7 > offsetWidth) {
                    imgMaxWidth = '70%'
                }
                setTimeout((_) => {
                    // 按钮显示为禁止 再去执行截图功能
                    html2canvas(enterDiv).then((canvas) => {
                        const dataURL = canvas.toDataURL('image/png')
                        this.dataURL = canvas.toDataURL('image/png')
                        _this.$refs.iframe.contentWindow.document.body.innerHTML = '' // 清空上一次打印的内容
                        _this.$refs.iframe.contentWindow.document.write(`<html><head><style media="print">@page { margin: 0mm; }body{margin-top: 50px; text-align: center;}</style></head><body><img style="width:${imgMaxWidth}" src=${dataURL}></body></html>`)
                        setTimeout((_) => {
                            _this.$refs.iframe.contentWindow.print()
                        }, 0)
                        _this.printDisabled = false
                    })
                }, 500)
            } else {
                // 元素设置指定位置隔断
                // var litArea = parseFloat(this.labelLong * this.labelWidth) + parseFloat(this.labelLong * 2)
                $('#A4Inner table').remove('.pageBreak')
                // var litArea = parseFloat((this.labelLong * 10) * (this.labelWidth * 10))
                // var allArea = 20 * 29
                // let allArea
                // if (this.dyzz === 1) {
                //     allArea = 210 * 297 // A4 纸张的面积
                // } else {
                //     allArea = 297 * 420 // A3 纸张的面积
                // }
                // var canNum = parseInt(allArea / litArea)
                // $('.labelTag').each(function (i, item) {
                //     if ((i + 1) % canNum === 0) {
                //         item.style.pageBreakInside = 'auto'
                //         item.style.pageBreakAfter = 'region'
                //         if (i + 1 < $('.labelTag').length) {
                //             $(this).after('<div class="pageBreak" style="page-break-after:always"></div>')
                //         }
                //     }
                // })

                _this.$refs.iframe.contentWindow.document.body.innerHTML = '' // 清空上一次打印的内容
                _this.$refs.iframe.contentWindow.document.write(`<html><head><style media="print">@page { margin: 0mm; }body{}table{width: 364%;justify-content: space-between;}.labelTag {zoom:364%;}</style></head><body>` + $('#A4Inner')[0].innerHTML + '</body></html>')
                setTimeout((_) => {
                    // _this.PageSetupNull()
                    _this.$refs.iframe.contentWindow.print()
                }, 300)
                _this.printDisabled = false
            }
        },
        // 解码
        HTMLDecode(text) {
            var temp = document.createElement('div')
            temp.innerHTML = text
            var output = temp.innerText || temp.textContent
            temp = null
            return output
        }
    }
}
</script>
<style media="print">
@page {
    size: auto;
    margin: 0mm;
}
</style>
<style>
@media print {
    html,
    body {
        height: inherit;
    }

    /* @page {
        size: A4;
        margin: 0;
    }

    .A4Inner {
        width: 210mm;
        min-height: 297mm;
    }

    @media (width: 420mm) {
        @page {
            size: A3;
            margin: 0;
        }

        .A4Inner {
            width: 297mm;
            min-height: 420mm;
        }
    } */
}
.seatHighlight {
    background: #c0c4cc !important;
}
.imgSeat {
    position: absolute;
    /* width: 42px; */
    /* height:  42px; */
    width: 60px;
    height: 60px;
    /* padding-top: 5px; */
    /* line-height: 40px; */
    text-align: center;
    color: #fff;
    /* z-index: -1; */
    overflow: hidden;
    font-size: 16px;
    padding: 7px 0;
    font-weight: bold;
}
.enterDiv {
    position: relative;
    top: 150px;
    margin: 0 100px 150px;
}
.peopleSeat {
    width: 100%;
    height: calc(100% - 20px);
    font-size: var(--portalFontSize13);
    font-weight: normal;
    padding: 0 4px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 限制为两行 */
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>

<style scoped lang="scss">
// @media print {
//     .labelTag {
//         page-break-inside:avoid
//     }
// }
.headBtn {
    z-index: 10;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    height: 60px;
    padding: 0 10px;
    box-sizing: border-box;
    background: #354052;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.main {
    display: flex;
    padding: 10px 10px;
    justify-content: space-between;
    margin: 10px;
    background: #fff;
    height: fit-content;
    min-height: calc(100vh - 380px);
    // height: 100% !important;
    // overflow-y: auto;
}
/* 隐藏滚动条（WebKit 浏览器） */
.mainBox::-webkit-scrollbar {
    display: none;
}

/* 隐藏滚动条（Firefox） */
.mainBox {
    // height: calc(100vh - 350px);
    overflow: auto;
    scrollbar-width: none; /* Firefox */
}
.left {
    width: calc(100% - 350px);
    min-height: calc(100vh - 380px);
    border: 1px solid #ddd;
    overflow-x: auto;
    height: 100% !important;
    padding-bottom: 20px;
    text-align: center;
}
.right {
    width: 350px;
    min-height: calc(100vh - 380px);
    border: 1px solid #ddd;
}
.title {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    font-size: var(--portalFontSize14);
    color: #409eff;
    border-bottom: 1px solid #ddd;
}
.seatType {
    padding: 10px;
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    border-bottom: 1px solid #ddd;
    width: 100%;
}
.seatType .span {
    font-size: var(--portalFontSize14);
}
.seatType .humanBlock {
    padding: 5px 8px;
    background: #999;
    color: #fff;
    margin: 5px 5px 0 5px;
    font-size: var(--portalFontSize13);
    width: 72px;
    text-align: center;
}
.seatType .cursorPdrag {
    cursor: pointer;
    background: #409eff !important;
}

.printCont {
    // display: flex;
    // align-items: center;
    // justify-content: center;
    display: grid;
    align-items: center;
    overflow-x: auto;
    /deep/ .enterDiv {
        //   left: unset !important;
        top: unset !important;
        margin: unset !important;
    }
}
.lyy-pd /deep/ .el-dialog__body {
    padding: 20px 20px 0;
}
.pleft {
    width: 410px;
    border-right: 1px solid #ddd;
    margin-bottom: 10px;
}
.pright {
    flex: 1;
    overflow: hidden;
    // padding-bottom: 20px;
    padding-left: 10px;
    .diaRight {
        overflow-y: auto;
        height: 100% !important;
        min-height: fit-content;
        width: 450px;
        display: flex;
        border-bottom: 1px solid #ddd !important;
        .humanBlock {
            cursor: pointer;
        }
    }
    .diaRight::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Edge */
    }

}
.ptitle {
    font-size: var(--portalFontSize14);
    color: #333;
}
table {
    border-collapse: collapse;
    width: 400px;
    // margin: 20px auto;
}
table tr td {
    border: 1px solid #e2e2e2;
    padding: 4px;
    height: 40px;
    color: #555;
    // font-size: var(--portalFontSize14);
    line-height: 30px;
    width: unset;
}
.A3Inner {
    width: 299px;
    min-height: 420px;
    height: 420px;
    margin: 20px auto;
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-around;
    // align-content: start;
    border: 1px solid #ddd;

    table tr td {
        transform: rotate(90deg);
    }
}
.A4Inner {
    width: 210px;
    min-height: 297px;
    height: 297px;
    margin: 20px auto;
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-around;
    // align-content: start;
    border: 1px solid #ddd;
}
.labelTag {
    border: 1px solid #ddd;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5px 0;
    font-weight: bold;
    letter-spacing: 2px;
}

.header-main {
    width: 100%;
    height: 36px;
    background-color: #fff;
    color: #333;
    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: 0 20px;
        .header-left {
            padding-left: 20px;
            .header-l {
                display: flex;
                align-items: center;
                & > span {
                    padding: 10px;
                }
                & > span:first-child {
                    padding-left: 0px;
                }
                .l-name {
                    display: inline-block;
                    font-size: 22px;
                    position: relative;
                    &::after {
                        content: '';
                        position: absolute;
                        right: 0;
                        top: 50%;
                        width: 2px;
                        height: 38%;
                        transform: translateY(-50%);
                        background-color: #fff;
                    }
                }
                .l-title {
                    font-size: var(--portalFontSize15);
                    line-height: 35px;
                }
            }
        }
    }
}

.head-left {
            display: flex;
            align-items: center;
            img {
                width: 44px;
                height: 44px;
            }
            .head-title {
                margin-left: 10px;
                margin-top: 10px;
                font-size: var(--portalFontSize16);
                color: #999999;
                .moduleT {
                    margin-right: 13px;
                    position: relative;
                }
                // .moduleT::after {
                //     position: absolute;
                //     content: '';
                //     width: 1px;
                //     height: 22px;
                //     right: -8px;
                //     top: 50%;
                //     background: #999999;
                //     transform: translateY(-50%);
                // }
                .formTapBtn {
                    display: flex;
                    margin-top: 10px;
                    font-family: MicrosoftYaHei;
                    color: #000000;
                    font-size: var(--portalFontSize14);
                    .tapItemBtn {
                        position: relative;
                        margin-right: 15px;
                    }
                    .active {
                        position: relative;
                        color: var(--subjectColor);
                        font-weight: bold;
                        &::after {
                            content: '';
                            position: absolute;
                            bottom: -14px;
                            left: 0px;
                            width: 100%;
                            height: 2px;
                            background: var(--subjectColor);
                        }
                    }
                    .tapItemBtn:hover {
                        cursor: pointer;
                        color: var(--subjectColor);
                    }
                }
            }
        }
</style>
